<videogular #vgApi
	[ngClass]="[
		vgApi.isDualPlaybackActive ? vgApi.dualPlaybackLayout.class : '',
		hasAudioOnly ? 'audioOnly' : '',
		isSmallSizePlayer ? 'smallSizePlayer' : ''
	]" [externalAudioTracks]="externalAudioTracks" [vgAutoPlay]="!isMobile && playbackOptions.length && autoPlay"
	[vgMutedAutoPlay]="true" [forceEndTimeInSec]="forceEndTimeInSec" [forceMute]="forceMute"
	[enforceSeekForwardLimit]="config?.enforceSeekForwardLimit"
	[initialSeekForwardLimitInSeconds]="config?.initialSeekForwardLimitInSeconds" [vgStartTime]="startTime"
	[disableUserPreferenceStore]="disableUserPreferenceStore" (mouseenter)="onMouseEnter()"
	(mouseleave)="onMouseLeave()" (vgActiveSourceChange)="onActiveSourceChangeInternal()"
	(vgComplete)="onCompleteInternal()" (vgError)="onError($event)" (vgPlayerReady)="onPlayerReadyInternal()"
	(vgSeeked)="onSeekedInternal($event.$currentTime)" (vgSeeking)="onSeekingInternal($event.$currentTime)"
	(vgUpdateState)="onUpdateStateInternal($event.$state)" (vgResetStartTime)="onResetStartTime($event)"
	current-state-class [currentState]="vgApi.currentState" [isLive]="isLive" (vbResized)="onResized($event)"
	[scrubAdapter]="scrubAdapter" [chapterHelper]="chapterHelper">

	@if (bannerHelper?.isAnyBannerVisible()) {
		<vb-video-banners [bannerHelper]="bannerHelper" [isSmallSizePlayer]="isSmallSizePlayer"
			[translations]="translations">
		</vb-video-banners>
	}

	<div
		[ngClass]="vgApi.chapterHelper?.isImagePresentInAnyChapter() && vgApi.chapterHelper?.showChapterImage ? 'chapterDisplayed' : 'noChaptersDisplayed'">
		<div
			[ngClass]="vgApi.chapterHelper?.isImagePresentInAnyChapter() && vgApi.chapterHelper?.showChapterImage ? 'playerContent' : 'noChaptersDisplayed'">
			<vg-poster [currentState]="vgApi.currentState"
				[hidden]="!vgApi.activeSource || !(posterUrl && vgApi.isSupportedPlaybackOptions && !vgApi.activeSource.isUnavailable)"
				[vgUrl]="posterUrl">
			</vg-poster>

			<vg-media [crossOrigin]="nativeCrossOrigin"
				[hidden]="!vgApi.activeSource || vgApi.activeSource.isUnavailable"
				[isControlsDisabled]="disableControls" [vgNativePlayBlacklist]="nativePlayBlacklist"
				[vgSrc]="vgApi.sources" vb-media-click [is360Enabled]="vgApi.activeSource?.is360Enabled"
				[isSmallSizePlayer]="isSmallSizePlayer" [controlsSurfaced$]="vgControls.controlSurfaced$"
				[isInitialPlay]="isInitPlayerLoad" [overlayControlsVisible]="overlayControlsVisible"
				[videoTitle]="videoTitle">
			</vg-media>

			<vg-conference-dual-hls [contentPlayerContainer]="contentPlayerContainerElement?.nativeElement"
				(onHlsLevelsChanged)="onHlsLevelsChanged($event)">
			</vg-conference-dual-hls>

			<vb-dual-playback-content-container #contentPlayerContainer
				[hidden]="!vgApi.activeSource || vgApi.activeSource.isUnavailable"
				[isControlsDisabled]="disableControls" vb-media-click>
			</vb-dual-playback-content-container>
		</div>

		<vg-chapter-display
			[hidden]="!vgApi.chapterHelper?.isImagePresentInAnyChapter() || !vgApi.chapterHelper?.showChapterImage"
			class="chapterDisplay" vb-media-click [controlsSurfaced$]="vgControls.controlSurfaced$"
			[isControlsDisabled]="disableControls" [isInitialPlay]="isInitPlayerLoad"
			[isSmallSizePlayer]="isSmallSizePlayer" [overlayControlsVisible]="overlayControlsVisible">
		</vg-chapter-display>
	</div>

	<vb-playback-manager #playbackManager [currentState]="vgApi.currentState" [playbackOptions]="playbackOptions"
		[sources]="vgApi.sources" (onCrossOriginSet)="onSetCrossOriginInternal($event)"
		(onCrossOriginError)="onCrossOriginErrorInternal()" (onInitialPlayback)="onInitialPlaybackInternal($event)"
		(onManualStreamSwitch)="onManualStreamSwitchInternal($event)"
		(onMediaFailover)="onMediaFailoverInternal($event)" (onMulticastError)="onMulticastErrorInternal($event)"
		(onPlaybackError)="onPlaybackErrorInternal($event)">
	</vb-playback-manager>

	<vg-hls [closedCaptionsTranslation]="translations.closedCaptions" [playbackManager]="playbackManager"
		(onHlsLevelsChanged)="onHlsLevelsChanged($event)">
	</vg-hls>


	<vg-360 [activeSource]="vgApi.activeSource" [hidden]="!vgApi.activeSource || vgApi.activeSource.isUnavailable"
		[isEnabled]="vgApi.activeSource && vgApi.activeSource.is360Enabled" [translations]="translations">
	</vg-360>
	@if (!!vgApi.c2paConfig && vgApi.activeSource && vgControls) {
		<vb-c2pa [translations]="translations" [activeSource]="vgApi.activeSource"
			[controlSurfaced]="vgControls.controlSurfaced$ | async"
			(failedC2paTimeMarkers)="onFailedC2paTimeMarkers($event)">
		</vb-c2pa>
	}
	@if(reactionCfg) {
		<reactions-player [reactions$]="reactionCfg.reactions$" [isHidden]="reactionCfg.hidden"></reactions-player>
	}
	@if (!playerControls?.hideMuteButton) {
		<button [ngClass]="[
					'mutedButtonOverlay',
					muteBtnOnLeft || (vgApi.activeSource && vgApi.activeSource.is360Enabled) ? 'mutedButtonOverlayOnLeft' : ''
				]" [hidden]="!(vgApi.activeSource &&
					vgApi.currentState === VgStates.PLAY &&
					!vgApi.volume &&
					!vgApi.activeSource.isUnavailable &&
					!forceMute &&
					!disableControls)" (click)="onMutedClick()">
			{{ translations.muted }}
		</button>
	}

	@if (!videoVerificationConfig?.isEnabled || videoVerificationConfig?.isVerified) {
		<vb-overlay-play-controls [isSmallSizePlayer]="isSmallSizePlayer" [isInitialPlay]="isInitPlayerLoad"
			[isInitialPlayNotAtStart]="isInitialPlayNotAtStart" [overlayBufferingManager]="bufferingManager"
			[translations]="translations" [vbStartAtManager]="vbStartAtManager"
			(overlayControlsDisplayChanged)="overlayControlsVisible = $event">
		</vb-overlay-play-controls>
	}

	@if (videoVerificationConfig?.isEnabled) {
		<vb-overlay-video-verification [config]="videoVerificationConfig" [isControlsDisplayed]="vgControlsDisplayed"
			[translations]="translations">
		</vb-overlay-video-verification>
	}

	@if (playerControls.chapterMenu && chapterHelper?.chapters().length && !!vgControls && vgControlsDisplayed) {
		<vg-chapters-menu [ngClass]="vgApi.activeSource?.is360Enabled ? 'chapterMenuWith360' : ''"
			[translations]="translations" [scrubAdapter]="scrubAdapter">
		</vg-chapters-menu>
	}

	<vg-controls #vgControls [currentState]="vgApi.currentState" [isInitialPlay]="isInitPlayerLoad"
		[isSmallSizePlayer]="isSmallSizePlayer" [forceVgControlsDisplay]="vgApi.forceVgControlsDisplay()"
		[disableControls]="disableControls"
		[hidden]="vgApi.isPlaybackPluginLoading || !vgApi.isSupportedPlaybackOptions || disableControls"
		(showVgControls)="vgControlsDisplayed = $event">

		<ng-container *vgControlDisplay="1">
			@if (isThumbnailEnabled) {
				<vg-scrub-bar-preview
					[ngClass]="scrubBarPreviewProperties?.isVisible ? 'visible' : 'hidden'"
					[ngStyle]="{'left': scrubBarPreviewProperties?.position}"
					[timeSecs]="scrubBarPreviewProperties?.timeSecs" [chapter]="scrubBarPreviewProperties?.chapter">
				</vg-scrub-bar-preview>
			}
		</ng-container>

		<ng-container *vgControlDisplay="3">
			@if (playerControls.playControls && !isLive) {
				<vg-scrub-bar [adapter]="scrubAdapter"
					[currentTime]="vgApi.currentTime" [isStartAtSeeking]="vbStartAtManager.isStartAtSeeking"
					[isSmallSizePlayer]="isSmallSizePlayer" [startAt]="startTime" [timeMarkers]="timeMarkers"
					[totalTimeWithFallback]="totalTimeWithFallback" [isThumbnailEnabled]="isThumbnailEnabled"
					(scrubBarPreviewEvent)="onScrubBarPreviewEvent($event)">
				</vg-scrub-bar>
			}
		</ng-container>

		<div class="controlButtonsBar">
			<span></span>
			@if (playerControls.playControls) {
				<vg-play-pause-button
					[hidden]="isLive && vgApi.currentState !== VgStates.STOP">
				</vg-play-pause-button>
			}

			@if (playerControls.playControls) {
				<div class="controlRoot"
					[hidden]="!(isLive && vgApi.currentState !== VgStates.STOP)">
					<button class="iconButton" type="button" [attr.aria-label]="translations.stop"
						[tooltip]="translations.stop" placement="auto" vbControlBarFocus (click)="vgApi.stop()">
						<span class="glyphicons stop"></span>
					</button>
				</div>
			}

			<span [hidden]="!playerControls.playControls || !isLive" class="liveIndicator">
				{{ translations.live }}
			</span>

			<vg-time-display *vgControlDisplay="4" [hidden]="!playerControls.playControls" [ngClass]="[
						'vgTimeDisplay',
						isLive || !totalTimeWithFallback ? 'isLiveHide' : ''
					]">
				{{ scrubAdapter.getCurrentTime() | vbPlayerTime }} / {{ scrubAdapter.getDuration() | vbPlayerTime }}
			</vg-time-display>

			<div class="flex" *vgControlDisplay="0">
				@if (playerControls.playControls && !isLive) {
					<vg-seek [translations]="translations"
						[isBackward]="true">
					</vg-seek>
				}
				@if (playerControls.playControls && !isLive) {
					<vg-seek [translations]="translations">
					</vg-seek>
				}
			</div>

			<ng-container *vgControlDisplay="2">
				@if (playerControls.chapterSeek && chapterHelper?.chapters().length) {
					<vg-skip-chapter
						[translations]="translations">
					</vg-skip-chapter>
				}
			</ng-container>

			<span *vgControlDisplay="0" style="flex-grow: 1"></span>

			@if (playerControls.volumeControl) {
				<vg-volume [translations]="translations" [isSmallSizePlayer]="isSmallSizePlayer">
				</vg-volume>
			}

			<ng-container *vgControlDisplay="3">
				@if (playerControls.chapterDisplay && chapterHelper?.isImagePresentInAnyChapter()) {
					<vg-toggle-chapter-display-button
						[translations]="translations">
					</vg-toggle-chapter-display-button>
				}
			</ng-container>

			<vb-subtitle-menu-button
				#subtitleMenuComp
				*vgControlDisplay="5"
				[activeSource]="vgApi.activeSource"
				[currentState]="vgApi.currentState"
				[currentTime]="vgApi.currentTime"
				[hidden]="!isSubtitleMenuButtonSurfaced"
				[isCaptionsAvailable]="isCaptionsAvailable"
				[subtitleLanguages]="subtitleOptions"
				[subtitleOptions]="config.subtitleOptions"
				[translations]="translations"
				[isSmallSizePlayer]="isSmallSizePlayer"
				[forcedCCOn]="config.forcedCCOn"
				[subtitleLangPreferenceOrder]="config.subtitleLangPreferenceOrder">
			</vb-subtitle-menu-button>

			<ng-container *vgControlDisplay="1">
				@if (!config.showOldDualPlaybackLayout && playerControls.dualLayoutControl && vgApi.isDualPlayback && DUAL_PLAYBACK_LAYOUT_OPTIONS?.length) {
					<vb-dual-playback-layout-menu-button
						#dualLayoutMenuComp [isSmallSizePlayer]="isSmallSizePlayer"
						[layoutOptions]="DUAL_PLAYBACK_LAYOUT_OPTIONS" [sources]="vgApi.sources"
						[translations]="translations">
					</vb-dual-playback-layout-menu-button>
				}
			</ng-container>
			@if(reactionCfg?.enabled) {
			<ng-container *vgControlDisplay="0">
				<reactions-menu [reactionCfg]="reactionCfg" [translations]="translations"
					(onReactionAdded)="onReactionAdded.emit($event)" (onReactionsHidden)="toggleReaction($event)">
				</reactions-menu>
			</ng-container>
			}
			<ng-container *vgControlDisplay="6">
				@if (playerControls.settings) {
					<vb-player-settings-menu [isLive]="isLive"
						[disableHotkeys]="isMobile || config.disableHotkeys"
						[disablePlaybackRate]="playerControls.disablePlaybackRate" [translations]="translations"
						[playbackManager]="playbackManager" [activeSource]="vgApi.activeSource"
						[playbackOptions]="playbackOptions">
					</vb-player-settings-menu>
				}
			</ng-container>

			@if (!isMobile || !(videoOverlayManager?.activeOverlays$ | async)?.length) {
				<vg-fullscreen-button
					[hidden]="!playerControls.fullscreen || isFullScreenButtonHidden">
				</vg-fullscreen-button>
			}
			<span></span>
		</div>
	</vg-controls>

	<vb-subtitle-display
		[areControlsVisible]="!!vgControlsDisplayed"
		[isSmallSizePlayer]="isSmallSizePlayer">
	</vb-subtitle-display>

	<vb-overlay-buffering-manager #bufferingManager [vbStartAtManager]="vbStartAtManager">
	</vb-overlay-buffering-manager>

	<initial-buffering-manager [activeSource]="vgApi.activeSource" [currentState]="vgApi.currentState"
		[currentTime]="vgApi.currentTime" [overlayBufferingManager]="bufferingManager"
		(onInitialBufferingChange)="onInitialBufferingChange($event.isInitialBuffering)">
	</initial-buffering-manager>

	<vb-overlay-buffering [isBuffering]="bufferingManager.isBuffering"
		[experiencedBufferingThresholdInMs]="experiencedBufferingThresholdInMs" [isSmallSizePlayer]="isSmallSizePlayer"
		(onBufferingSpinner)="bufferingSpinner($event.duration)">
	</vb-overlay-buffering>


	<vb-playback-plugin-loading class="vbPlaybackPluginLoading" [hidden]="!vgApi.isPlaybackPluginLoading">
		{{ translations.loadingPlugin }}
	</vb-playback-plugin-loading>

	<vb-no-supported-playbacks [hidden]="vgApi.isSupportedPlaybackOptions !== false"
		[isSmallSizePlayer]="isSmallSizePlayer" [playbackManager]="playbackManager" [translations]="translations">
	</vb-no-supported-playbacks>

	<vb-playback-unavailable [hidden]="!vgApi.activeSource || !vgApi.activeSource.isUnavailable"
		[isSmallSizePlayer]="isSmallSizePlayer" [mediaError]="mediaError" [translations]="translations"
		[playbackUnavailableMsgTemplate]="playbackUnavailableMsgTemplate">
	</vb-playback-unavailable>

	@if (debugMode && hlsLevelsModel && vgApi.activeSource && !vgApi.activeSource.isUnavailable) {
		<hls-level-picker
			[hlsLevelsModel]="hlsLevelsModel">
		</hls-level-picker>
	}

	<vb-start-at-manager #vbStartAtManager [currentTime]="vgApi.currentTime" [playbackOptions]="playbackOptions"
		[startAt]="startTime" [startAtResume]="!!startAtResume" [totalTime]="vgApi.totalTime">
	</vb-start-at-manager>

	<vb-playerjs-receiver [currentState]="vgApi.currentState" [currentTime]="vgApi.currentTime"
		[isComplete]="isComplete">
	</vb-playerjs-receiver>

	@if (!isMobile && !config.disableHotkeys) {
		<ng-container vbHotkeysRegistration [translations]="translations"
			[ccButtonVisible]="isSubtitleMenuButtonSurfaced" [isVolumeVisible]="!forceMute"
			[isDualPlayback]="playerControls.dualLayoutControl && vgApi.isDualPlayback">
		</ng-container>
	}

</videogular>
